import { render } from "./UserPaymentHistory.vue?vue&type=template&id=ec963a74&scoped=true"
import script from "./UserPaymentHistory.vue?vue&type=script&lang=js"
export * from "./UserPaymentHistory.vue?vue&type=script&lang=js"

import "./UserPaymentHistory.vue?vue&type=style&index=0&id=ec963a74&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec963a74"]])

export default __exports__